var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { addSeconds } from 'date-fns';
var useDateRangeFormat = function (_a) {
    var invalidText = _a.invalidText;
    var i18n = useTranslation().i18n;
    var formatDatePeriod = React.useCallback(function (from, to) {
        if (!from || !to) {
            return invalidText !== null && invalidText !== void 0 ? invalidText : '-';
        }
        var fromDate = new Date(from);
        var toDate = addSeconds(new Date(to), -1);
        var baseOption = {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };
        var toOption = __assign({}, baseOption);
        if (fromDate.getFullYear() === toDate.getFullYear()) {
            toOption.year = undefined;
        }
        return "".concat(fromDate.toLocaleString(i18n.language, baseOption), " - ").concat(toDate.toLocaleString(i18n.language, toOption));
    }, [i18n.language, invalidText]);
    return formatDatePeriod;
};
export default useDateRangeFormat;
